import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { FBMAccountPicker, TabPanel } from 'shared';

import { CreateFBMUserAccount } from './createFBMUserAccount';
import { ViewFBMUserAccounts } from './viewFBMUserAccounts';

function FBMUserAccounts() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <FBMAccountPicker />
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewFBMUserAccounts_Tab" label="View" value="0" />
                <Tab id="CreateFBMUserAccount_Tab" label="Create" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewFBMUserAccounts />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateFBMUserAccount />
            </TabPanel>
        </Paper>
    );
}

export { FBMUserAccounts };
